import React from 'react';
import './CareersHero.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';

/**
 * Renders the careers hero
 * @param {string} backgroundImage
 * @param {string} title
 * @param {string} body
 * @param {string} ctaText
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const CareersHero = ({ backgroundImage, title, body, ctaText = '', ctaLink = '' }) => (
  <div className="c-careers-hero" style={{ backgroundImage: `url(${backgroundImage})` }}>
    <div className="c-careers-hero__inner">
      <div className="c-careers-hero__title h4-right-grotesk color-black">
        <h4>{title}</h4>
      </div>
      <div className="c-careers-hero__body color-black body-1">
        <p>{body}</p>
      </div>
      {(ctaLink || ctaText) && (
        <div className="c-careers-hero__cta">
          <CTAButton
            type={'primary'}
            link={ctaLink}
            text={ctaText}
            target={'_self'}
            additionalClasses={'cta primary-black'}
          />
        </div>
      )}
    </div>
  </div>
);

export default CareersHero;
